import { createOptionsFrom } from "@/lib/common/Option";

export const ProgressSummarySortOrderLabels = {
	Alphabetical: "Alphabetical",
	MarketValue: "Market Value",
	Progress: "Progress",
	CardNumber: "Card Number"
} as const;

export type ProgressSummarySortOrder = keyof typeof ProgressSummarySortOrderLabels;

export const ProgressSummarySortOrderOptions = createOptionsFrom(ProgressSummarySortOrderLabels);
